export default __webpack_public_path__ + "static/media/Klamberg.6b7ba8fa.jpg";